/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, delay, put } from 'redux-saga/effects'
import { createSagas } from 'src/helpers/redux'
import store from 'src/store'

import * as twilioService from 'src/services/communication/twilio'
import { realtimeService } from 'src/services/realtime'
import * as searchService from 'src/services/search'

import { setters } from './index'
import { actions, Actions } from './actions'
import { selectors } from './selectors'
import { ICall } from './types'
import { IResponse } from 'src/services/accounts/http'

export default createSagas<Actions>(actions, {
  setWidgetOptions: function* ({ payload }) {
    yield put(setters.setWidgetState(payload))
  },

  setTwillioState: function* ({ payload }) {
    yield put(setters.setTwillioState(payload))
  },

  fetchMoreHistoryCalls: {
    effect: 'latest',
    saga: function* ({ payload }) {
      const callsHistory: IResponse<ICall[]> = yield call(
        twilioService.getCallHistory,
        payload
      )

      yield put(setters.setMoreHistoryCall(callsHistory))
    },
  },

  getHistoryCalls: {
    effect: 'latest',
    saga: function* ({ payload }) {
      yield delay(500)

      if (payload.search) {
        realtimeService.offOnly({
          key: actions.getHistoryCalls.pending.toString() + '/insert',
          channel: 'communications:call_logs',
          event: 'insert',
        })
        realtimeService.offOnly({
          key: actions.getHistoryCalls.pending.toString() + '/update',
          channel: 'communications:call_logs',
          event: 'update',
        })
      } else {
        realtimeService.only<ICall>(
          {
            key: actions.getHistoryCalls.pending.toString() + '/insert',
            channel: 'communications:call_logs',
            event: 'insert',
            // filter: payload.userId? 'account.user_id == `"'+ payload.userId+'"`':undefined
          },
          (data) => {
            const isAssignUser = payload.assignedUserId
              ? data.account.assignedUserIds?.includes(payload.assignedUserId)
              : null
            // console.debug('event insert:', data)
            if (
              (payload.assignedUserId ? isAssignUser : true) &&
              (payload.accountDriver
                ? payload.accountDriver === data.account.driver
                : true) &&
              (payload.accountId ? payload.accountId === data.account.id : true)
            )
              store.dispatch(setters.setHistoryCallsAppend(data))
          }
        )
        realtimeService.only<ICall>(
          {
            key: actions.getHistoryCalls.pending.toString() + '/update',
            channel: 'communications:call_logs',
            event: 'update',
            // filter:  payload.userId? 'account.user_id == `"'+ payload.userId+'"`':undefined
          },
          (data) => {
            const isAssignUser = payload.assignedUserId
              ? data.account.assignedUserIds?.includes(payload.assignedUserId)
              : null
            if (
              (payload.assignedUserId ? isAssignUser : true) &&
              (payload.accountDriver
                ? payload.accountDriver === data.account.driver
                : true) &&
              (payload.accountId ? payload.accountId === data.account.id : true)
            )
              store.dispatch(setters.setHistoryCallsUpdate(data))
          }
        )
      }

      const callsHistory: IResponse<ICall[]> = yield call(
        twilioService.getCallHistory,
        payload
      )

      yield put(setters.setHistoryCalls(callsHistory))
    },
  },

  getActiveCalls: function* ({ payload }) {
    const callsHistory: IResponse<ICall[]> = yield call(
      twilioService.getCallHistory,
      payload
    )

    yield put(setters.setActiveCalls(callsHistory.data))

    realtimeService.only<ICall>(
      {
        key: actions.getActiveCalls.pending.toString() + '/insert',
        channel: 'communications:call_logs',
        event: 'insert',
        // filter: payload.userId? 'account.user_id == `"'+ payload.userId+'"`':undefined
      },
      (data) => {
        // console.debug('event insert:', data, payload)
        const isAssignUser = payload.assignedUserId
          ? data.account.assignedUserIds?.includes(payload.assignedUserId)
          : null

        if (
          (payload.assignedUserId ? isAssignUser : true) &&
          (payload.accountDriver
            ? payload.accountDriver === data.account.driver
            : true) &&
          (payload.accountId ? payload.accountId === data.account.id : true)
        )
          store.dispatch(setters.setActiveCalls([data]))
      }
    )
    realtimeService.only<ICall>(
      {
        key: actions.getActiveCalls.pending.toString() + '/update',
        channel: 'communications:call_logs',
        event: 'update',
        // filter:  payload.userId? 'account.user_id == `"'+ payload.userId+'"`':undefined
      },
      (data) => {
        // console.debug('event update:', data, payload)
        const isAssignUser = payload.assignedUserId
          ? data.account.assignedUserIds?.includes(payload.assignedUserId)
          : null
        if (
          (payload.assignedUserId ? isAssignUser : true) &&
          (payload.accountDriver
            ? payload.accountDriver === data.account.driver
            : true) &&
          (payload.accountId ? payload.accountId === data.account.id : true)
        )
          store.dispatch(setters.setActiveCalls([data]))
      }
    )
    yield put(actions.runActiveCallsAutoClear.pending())
  },
  runActiveCallsAutoClear: function* ({ payload }) {
    yield put(setters.setActiveCallsAutoClear())
    yield delay(60 * 1000)
    yield put(actions.runActiveCallsAutoClear.pending())
  },
  setActiveCallsClose: function* ({ payload }) {
    yield put(setters.setActiveCallsClose(payload))
  },
  setHistoryCallsUpdateObject: function* ({ payload }) {
    const { data, context } = payload

    yield put(
      setters.setHistoryCallsUpdateObject({
        uniqId: data.uniqId,
        objectSchemeIdentifier: data.objectSchemeIdentifier,
        primary: data.primary || '',
        secondary: data.secondary || '',
        icon: data.icon || '',
        parentObjectUniqId: data.parentObject?.uniqId || '',
      })
    )
  },
})
